import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';

/**
 * Green folder "What to Include" link shown under the "Additional Requirements
 * or Notes" and "Additional Photos" fields. Restores the legacy
 * `Icon_Upload.png` affordance that opened the "#WhatToInclude" modal.
 */
export function WhatToIncludeLink() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div>
        <a
          role="button"
          className="form-label text-primary fs-5 d-inline-block mb-1"
          style={{ cursor: 'pointer' }}
          onClick={() => setOpen(true)}
        >
          <img src="/images/ICON/Icon_Upload.png" alt="" /> What to Include
        </a>
      </div>

      <Modal show={open} onHide={() => setOpen(false)} size="lg" centered scrollable>
        <Modal.Header closeButton />
        <Modal.Body className="px-4 pt-0">
          <h1 className="text-center">What to include in Additional Requirements or Notes</h1>
          <p className="text-center">
            Add any additional information we should know (i.e. special
            requirements, project details, etc). 160 character maximum.
          </p>
          <h1 className="text-center">What to include in Additional Photos</h1>
          <p className="text-center">
            Please include any photos of the installation site or existing
            structure you may have to help us better match you with a structure.
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
}
